<!-- 运维视图：值班日志：接班备注 -->
<template>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>接班备注</span>
            <el-button v-if="logbook != null && logbook.status === 'HANDLED'" @click="save" style="float: right; padding: 3px 0;" type="text">
                <i class="el-icon-files">
                </i>
                保存
            </el-button>
        </div>
        <div style="height:180px;">
            <el-form ref="form">
                <el-form-item>
                    <el-input :disabled="logbook == null || logbook.status !== 'HANDLED'"
                              @blur="handleBlur"
                              type="textarea" v-model="acceptRemark" maxlength="120" show-word-limit  placeholder="限120字符">
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
    </el-card>
</template>

<script>
    import DutyServer from "@/api/duty";

    export default {
        name: "operation-board-duty-accept-remark",
        props: {
            duties: {},
        },
        data() {
            return {
                acceptRemark: null,
                oldAcceptRemark: null,
            };
        },
        computed: {
            logbook() {
                let duties = this.duties;
                let first = duties.first;
                let logbook;
                if (first != null && first.logbook != null) {
                    logbook = first.logbook;
                }
                return logbook;
            },
        },
        watch: {
            logbook: {
                deep: true,
                immediate: true,
                handler() {
                    this.load();
                }
            },
        },
        methods: {
            async load() {
                let logbook = this.logbook;

                let acceptRemark;
                acceptRemark = logbook == null ? null : logbook.acceptRemark;
                this.acceptRemark = acceptRemark;
                this.oldAcceptRemark = acceptRemark == null ? null : String(acceptRemark);
                return Promise.resolve(logbook);
            },
            save() {
                this.saveAcceptRemark();
            },
            async saveAcceptRemark() {
                let logbook = this.logbook;
                let logbookId = logbook.logbookId == null ? null : logbook.logbookId;
                let acceptRemark = this.acceptRemark;
                if (logbookId != null) {
                    let response = await DutyServer.logbook.updateAcceptRemark(logbookId, acceptRemark);
                    if (response.status === 200 && response.data.code === 200) {
                        acceptRemark = response.data.result;
                        this.oldAcceptRemark = acceptRemark == null ? null : String(acceptRemark);
                        this.$message.success('接班备注保存成功！');
                    } else {
                        this.$message.error(response.data.message);
                    }
                }
                return acceptRemark;
            },
            handleBlur() {
                if (this.acceptRemark !== this.oldAcceptRemark) {
                    this.$confirm('接班备注已修改，确定保存吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                       this.save();
                    }, () => {
                        // this.acceptRemark = this.oldAcceptRemark == null ? null : String(this.oldAcceptRemark);
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>
